export const applyPagination = <T>(
  items: T[],
  page: number,
  rowsPerPage: number,
): T[] => items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
